//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import API from "~/api/api";
import { usCategories } from "~/src/butter-categories";

export default {
  layout: "default-no-sticky",
  middleware: "cacheControl",
  computed: {
    nextPagePath() {
      if (this.$route.params.categorySlug) {
        return `/guides/categories/${this.$route.params.categorySlug}/page/${this.nextPage}`;
      } else {
        return `/guides/page/${this.nextPage}`;
      }
    },
    previousPagePath() {
      if (this.$route.params.categorySlug) {
        return `/guides/categories/${this.$route.params.categorySlug}/page/${this.previousPage}`;
      } else {
        return `/guides/page/${this.previousPage}`;
      }
    },
    metaTitle() {
      let title = "";
      if (this.categoryName) {
        title += `${this.categoryName} `;
      }
      title += "Help Guides and Resources |";
      if (this.currentPage > 1) {
        title += ` Page ${this.currentPage} |`;
      }
      title += " LegalNature";
      return title;
    },
    categoriesForLocale() {
      return usCategories;
    },
  },

  data() {
    return {
      posts: [],
      postCount: 0,
      nextPage: null,
      previousPage: null,
      currentPage: 1,
      categoryName: null,
      childCategories: [],
      loading: true,
      error: false,
    };
  },
  methods: {},

  head() {
    if (!this.loading || !this.error) {
      let canonicalLink = "https://www.legalnature.com/guides";
      if (this.$route.params.categorySlug) {
        canonicalLink += `/categories/${this.$route.params.categorySlug}`;
      }
      if (this.$route.params.page) {
        canonicalLink += `/page/${this.$route.params.page}`;
      }

      return {
        title: this.metaTitle,
        meta: [{ name: "description", content: "" }],
        link: [
          {
            rel: "canonical",
            href: canonicalLink,
          },
        ],
      };
    } else {
      return {
        title: "Help Guides and Resources | LegalNature",
        meta: [{ name: "description", content: "" }],
      };
    }
  },

  async asyncData({ app, params, query, error }) {
    try {
      let articleTag = "us-article";
      // Converting to number necessary because somehow params.page, in some cases, is returning tel:8888811139.
      // Which with Number() conversion, becomes NaN.
      // So currentPage will be 1.
      let currentPage = Number(params.page);
      if (!currentPage) {
        currentPage = 1;
        app.$bugsnag.notify(
          new Error("Bad page number for guides index"),
          (event) => {
            event.addMetadata("params-data", { ...params });
            event.addMetadata("query-data", { ...query });
          }
        );
      }
      let categoryName;
      let postList;
      let parent;
      let childCategories;

      if (params.categorySlug) {
        let category = await API.butterCategories.get(
          app.$axios,
          params.categorySlug,
          {
            page: currentPage,
            tag_slug: articleTag,
          }
        );
        postList = category.post_list;
        categoryName = category.name;
        parent = category.parent;
        childCategories = category.children;
      } else {
        postList = await app.$butter.post.list({
          page_size: 10,
          page: currentPage,
          tag_slug: articleTag,
        });
      }
      let posts = postList.posts;
      let nextPage = postList.nextPage;
      let previousPage = postList.previousPage;
      let postCount = postList.postCount;

      return {
        posts,
        postCount,
        parent,
        nextPage,
        previousPage,
        currentPage,
        categoryName,
        childCategories,
        loading: false,
        error: false,
      };
    } catch (e) {
      console.error(e);

      error({ message: "Error fetching data..." });
    }
  },
};
